import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { routes } from "./app.routes";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";

// Scrollbar
import { NgScrollbarModule } from "ngx-scrollbar";

// Material + Forms
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Interceptors & Toastr
import { AuthInterceptor } from "./services/interceptors/auth.interceptor";
import { provideToastr } from "ngx-toastr";
import { LoaderInterceptor } from "./services/interceptors/loader.interceptor";
import { ErrorInterceptor } from "./services/interceptors/error.interceptor";
import { provideQuillConfig, QuillModule } from "ngx-quill";
import { QUILL_GLOBAL_PROVIDER } from "./editor/quill.config";
import { EnterpriseToastComponent } from "./shared/toastr/enterprise-toast.component";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    // ✅ Router setup
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      }),
      withComponentInputBinding()
    ),

    QUILL_GLOBAL_PROVIDER,
    // ✅ Global Providers
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(), // required for toastr
    provideToastr({
      timeOut: 4000,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      tapToDismiss: true,
      easeTime: 250,
      toastComponent: EnterpriseToastComponent,
    }),

   

    // ✅ Imported Modules
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      NgScrollbarModule,
      QuillModule
    ),

    // ✅ HTTP Interceptor
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
};
